// Signin modal.  Used whenever the user is not authenticated, and has to sign
// in.

import * as ForgotPassword from './forgot_password';
import * as Passwordless   from './passwordless';
import * as User           from '../../user';
import { compose }         from 'redux';
import { connect }         from 'react-redux';
import { Provider }        from 'react-redux';
import Credentials         from './credentials';
import ProgressIndicator   from '../../components/progress_indicator';
import React               from 'react';
import renderAsPopup       from '../../components/render_as_popup';
import store               from '../../store';


export default renderAsPopup(SignInPage, 'ViewSigninPage');


function SignInPage({ popup }) {
  return (
    <Provider store={store}>
      <React.Fragment>
        <ProgressIndicator/>
        <div className="page-content">
          <div className="login-screen-content block">
            <div className="login-screen-title"/>
            <SignInOptions popup={popup}/>
          </div>
        </div>
      </React.Fragment>
    </Provider>
  );
}

class SignInOptionsComponent extends React.PureComponent {

  constructor(props) {
    super(props);
    this.handleLinkClick        = this.handleLinkClick.bind(this);
    this.onForgotPasswordSubmit = this.onForgotPasswordSubmit.bind(this);
    this.onPasswordlessSubmit   = this.onPasswordlessSubmit.bind(this);
    this.authenticate           = this.authenticate.bind(this);

    this.state = {
      page: 'login'
    };
  }

  async onForgotPasswordSubmit({ email }) {
    const { forgotPassword } = this.props;

    await forgotPassword(email);
    this.setState({ page: 'forgot_password_thank_you', email });
  }

  async onPasswordlessSubmit({ phone }) {
    const { passwordless } = this.props;

    await passwordless(phone);
    this.setState({ page: 'passwordless_thank_you', phone });
  }

  handleLinkClick(page) {
    return event => {
      event.preventDefault();
      this.setState({ page });
    };
  }

  async authenticate({ username, password }) {
    await this.props.authenticate({ username, password });

    const { popup } = this.props;
    setTimeout(popup.close, 300);
  }

  render() {
    const { page }  = this.state;
    const { email } = this.state;
    const { phone } = this.state;

    switch (page) {
      case 'forgot_password': {
        return (
          <ForgotPassword.Form
            onSubmit={this.onForgotPasswordSubmit}
            onLoginClick={this.handleLinkClick('login')}/>
        );
      }

      case 'forgot_password_thank_you': {
        return (
          <ForgotPassword.ThankYou email={email} onLoginClick={this.handleLinkClick('login')}/>
        );
      }

      case 'passwordless': {
        return (<Passwordless.Form
          onSubmit={this.onPasswordlessSubmit}
          onLoginClick={this.handleLinkClick('login')}/>
        );
      }

      case 'passwordless_thank_you': {
        return (
          <Passwordless.ThankYou
            phone={phone}
            onLoginClick={this.handleLinkClick('login')}/>
        );
      }

      default: {
        return (
          <Credentials
            authenticate={this.authenticate}
            onForgotPasswordClick={this.handleLinkClick('forgot_password')}
            onPasswordlessClick={this.handleLinkClick('passwordless')}/>
        );
      }
    }
  }

}


const SignInOptions = connect(
  null,
  dispatch => ({
    authenticate:   compose(dispatch, User.authenticate),
    forgotPassword: compose(dispatch, User.forgotPassword),
    passwordless:   compose(dispatch, User.passwordless)
  })
)(SignInOptionsComponent);
